import { render, staticRenderFns } from "./OpportunityDetailsTab.vue?vue&type=template&id=6c4b1e92&"
import script from "./OpportunityDetailsTab.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetailsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports